import React from "react";
import { useSectionTracking } from "../hooks/useSectionTracking";

/**
 * Component wrapper for automatic section tracking
 * Automatically tracks when the section comes into view and scroll depth
 *
 * @param {string} sectionName - Name/identifier of the section
 * @param {string} sectionId - Optional section ID
 * @param {Object} options - Tracking options (threshold, trackScroll, etc.)
 * @param {React.ReactNode} children - Section content
 * @param {string} className - Optional CSS class
 *
 * @example
 * <TrackedSection sectionName="hero_section" sectionId="hero">
 *   <div>Hero Content</div>
 * </TrackedSection>
 */
const TrackedSection = ({
  sectionName,
  sectionId = null,
  options = {},
  children,
  className = "",
  ...props
}) => {
  const { sectionRef, isVisible } = useSectionTracking(
    sectionName,
    sectionId,
    options,
  );

  return (
    <div ref={sectionRef} className={className} {...props}>
      {children}
    </div>
  );
};

export default TrackedSection;
